import React from 'react';

type SystemDetails = {
  id: string;
  serialNumber: string;
  os: string;
  cpu: string;
  ram: string;
  hardDisk: string;
};

const sampleSystemDetails: SystemDetails = {
  id: '467859',
  serialNumber: 'FVGY1XGHV22',
  os: 'OS X (13.7.3)',
  cpu: 'Intel ® core ™ i5-74567 CPU @ 2.30GHz',
  ram: '8GB',
  hardDisk: 'Macintosh HD 113 GB (53 GB Available)',
};

const DetailItem = ({ label, value }: { label: string; value: string }) => (
  <div>
    <p className="text-sm text-gray-400">{label}</p>
    <p className="text-sm text-white">{value}</p>
  </div>
);

const InfoSystemCard: React.FC = ({ deviceData }) => {
  // console.log('deviceData', deviceData);
  return (
    <div className="bg-[#1C1C1D] text-white rounded-xl p-6 w-full max-w-3xl shadow-md">
      {/* Header */}
      <div className="mb-6">
        <button className="border border-white/30 text-sm px-4 py-1 rounded-full bg-black/30 text-white">System Details</button>
      </div>

      {/* Grid layout for details */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-10 text-sm">
        <DetailItem label="ID" value={deviceData?.deviceName} />
        <DetailItem label="CPU" value={deviceData?.cpuName} />
        <DetailItem label="Serial Number" value={deviceData?.serialNumber} />
        <DetailItem label="Mac Address" value={deviceData?.macAddress} />
        <DetailItem label="IP Address" value={deviceData?.ipAddress} />
        <DetailItem label="RAM" value={deviceData?.ram ? `${(deviceData.ram / 1024 ** 3).toFixed(2)} GB` : 'N/A'} />
        <DetailItem label="OS" value={deviceData?.osName} />
        <DetailItem label="Hard Disk" value={deviceData?.hardDisk} />
      </div>
    </div>
  );
};

export default InfoSystemCard;
